import { useContext } from 'react';

import { SpecialOfferActionContext, SpecialOfferValueContext } from './context';

const useSpecialOfferValue = () => {
  const context = useContext(SpecialOfferValueContext);
  if (!context) {
    throw new Error(
      'useSpecialOfferValue must be used within a <SpecialOfferFormContext />',
    );
  }
  return context;
};

const useSpecialOfferAction = () => {
  const context = useContext(SpecialOfferActionContext);
  if (!context) {
    throw new Error(
      'useSpecialOfferAction must be used within a <SpecialOfferFormContext />',
    );
  }
  return context;
};

export { useSpecialOfferAction, useSpecialOfferValue };
